module.exports = __webpack_public_path__ + "img/freeplay-predictor-btn.78b9026b.png";